import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { browserHistory } from 'react-router';

import { 
  getAccountList,
  cloneRegulationList,
  deleteRegulationList,
  activateDeactivateRegulationList,
  clearRegulationError,
  updateRegulationMigrationStatus,
  migrateRegulation
} from '../../../../actions/us_privacy_regulation_actions';
import { getDidomiOrganizations } from '../../../../actions/account_actions';
import { useActions } from "../../../../hooks";
import RegulationListGeneric from "../../vendor_list_v2/RegulationListGeneric";
import { hasFeature } from "../../../utils";
import FrameworkSelectionModal from "./FrameworkSelectionModal";

const USPrivacyRegulationList = (props) => { 
  const isGlobalStandardFlow = props.route.globalStandard;
  const [openFrameworkSelectionModal, setOpenFrameworkSelectionModal] = useState(false);  
  const [getUSPrivacyAccountsList, cloneRegulation, deleteRegulation, activateDeactivateRegulation, clearRegulationErrorAction, updateMigrationStatus, migrateRegulationToDidomi, getDidomiOrgs] = useActions([getAccountList, cloneRegulationList, deleteRegulationList, activateDeactivateRegulationList, clearRegulationError, updateRegulationMigrationStatus, migrateRegulation, getDidomiOrganizations]);

  const currentUser = useSelector(state => state.accountState.getIn(['userDetails', 'value'])) ?? {};
  const sites = useSelector(state => state.siteState.getIn(['sites', 'value']))?.filter((s) => s.type !== 'property_group' && s.domain && !s.domain.includes('-group-'));
  const siteGroups = useSelector(state => state.siteState.getIn(['siteGroups', 'value']))
  const error = useSelector(state => state.usPrivacyReducerState.getIn(['vendorList', 'error']));
  const accountsList = useSelector(state => state.usPrivacyReducerState.getIn(['vendorList', 'value']))?.filter((reg) => !(reg?.legislation === "state" && !reg?.nonIab));
  const vendorListsPending = useSelector( state => state.usPrivacyReducerState.getIn(['vendorList', 'pending']))
  const didomiOrganizations = useSelector(state => state.accountState.getIn(['didomiOrganizations', 'value']));
  const editUSPRegulation = (regulationId) => {
    browserHistory.push(`${isGlobalStandardFlow ? "/global_enterprise" : "/us_privacy/regulations"}/edit?regulationId=${regulationId}`);
  };

  const [tableStates, setTableStates] = useState({
    sorter: {},
    filters: {},
    pagination: {}
  });

  const calculateAccess = (sites, vlSites) => {
    return false;
    // if (currentUser?.allSiteAccess) return false;
    // const siteSet = new Set(sites);
    // let viewOnly = false;
    // vlSites.forEach(s => {
    //   if (!siteSet.has(s)) viewOnly = true;
    // });
    // return viewOnly;
  };

  
  useEffect(() => {
    getUSPrivacyAccountsList(isGlobalStandardFlow)
  },[isGlobalStandardFlow])

  useEffect(() => {
    getDidomiOrgs()
  },[])

  const handleCreate = (framework) => {
    if(isGlobalStandardFlow) {
      browserHistory.push(`/global_enterprise/create`);
    } else {
      browserHistory.push(`/us_privacy/regulations/create?framework=${framework}`);
    }
  }

  let readOnly = false;
  if(!currentUser?.allFeatureAccess) {
    let comparaterString = isGlobalStandardFlow ? 'Vendor List - Global Enterprise' : 'Vendor List - U.S. Multi-State';
    if(currentUser?.featureAccess && !currentUser?.featureAccess.includes(comparaterString)) {
      readOnly = true;
    }
  }

  const isAccountPartOfWave1 = true;

  return (
    <>
      <RegulationListGeneric
        currentUser={currentUser}
        vendorLists={accountsList}
        vendorListError={error}
        sites={sites}
        siteGroups={siteGroups}
        vendorListsPending={vendorListsPending}
        usnat={props.route.usnat}
        nonIab={props.route.nonIab}
        globalStandard={isGlobalStandardFlow}
        readOnly={readOnly}
        calculateAccess={calculateAccess}
        entity={"Regulation"}
        handleCreate={() => {isGlobalStandardFlow ? handleCreate() : setOpenFrameworkSelectionModal(true)}}
        handleEdit={editUSPRegulation}
        cloneVendorList={(...args) => cloneRegulation(isGlobalStandardFlow, ...args)}
        deleteVendorList={(...args) => deleteRegulation(isGlobalStandardFlow, ...args)}
        clearVendorListError={clearRegulationErrorAction}
        activateDeactivateVendorList={(...args) => activateDeactivateRegulation(isGlobalStandardFlow, ...args)}
        updateDidomiMigrationStatus={(...args) => updateMigrationStatus(isGlobalStandardFlow, ...args)}
        migrateVendorList={(...args) => migrateRegulationToDidomi(isGlobalStandardFlow, ...args)}
        didomiOrganizations={didomiOrganizations}
        isAccountPartOfWave1={isAccountPartOfWave1}
        tableStates={tableStates}
        setTableStates={setTableStates}
      />
      {openFrameworkSelectionModal ? (
        <FrameworkSelectionModal
          isModalOpen={openFrameworkSelectionModal}
          handleCreate={handleCreate}
          onCancel={() => setOpenFrameworkSelectionModal(false)}
        />
       ): null}
    </>
  )
}

export default USPrivacyRegulationList
